import { Loader2 } from 'lucide-react';

/**
 * Full-screen centered loading spinner.
 * Used while non-authenticated routes (login, auth callbacks) are loading.
 * Announces "Loading" to assistive tech via `role="status"`.
 */
export function LoadingSpinner() {
  return (
    <div className="flex h-dvh items-center justify-center" role="status" aria-label="Loading">
      <Loader2 aria-hidden="true" className="text-muted-foreground h-8 w-8 animate-spin" />
      <span className="sr-only">Loading</span>
    </div>
  );
}
